import { render, staticRenderFns } from "./distribution-performance.vue?vue&type=template&id=59f56055&scoped=true&"
import script from "./distribution-performance.vue?vue&type=script&lang=js&"
export * from "./distribution-performance.vue?vue&type=script&lang=js&"
import style0 from "./distribution-performance.vue?vue&type=style&index=0&id=59f56055&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f56055",
  null
  
)

export default component.exports